import { render, staticRenderFns } from "./frontDesk.vue?vue&type=template&id=756d2b5e&scoped=true&"
import script from "./frontDesk.vue?vue&type=script&lang=js&"
export * from "./frontDesk.vue?vue&type=script&lang=js&"
import style0 from "./frontDesk.vue?vue&type=style&index=0&id=756d2b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d2b5e",
  null
  
)

export default component.exports